import { P } from 'components'
import { useLayoutEffect, useRef, useState } from 'react'
import { formatDateOnlyPMB } from 'utils/formatDate'

const NoteItem = ({ item, itemIndex }) => {
  const { ts, notes: content } = item
  const [isExpanded, setIsExpanded] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const textRef = useRef(null)

  useLayoutEffect(() => {
    if (textRef.current) {
      if (textRef.current.scrollHeight > textRef.current.clientHeight) {
        setShowButton(true)
      }
    }
  }, [content])

  const toggleNote = () => {
    setIsExpanded((prev) => !prev)
  }

  return (
    <div
      className="d-flex flex-column"
      data-testid={`expandable-note-item-${itemIndex}`}
    >
      {ts && (
        <span style={{ fontSize: '0.85rem', color: '#666' }}>
          {formatDateOnlyPMB(ts)}
        </span>
      )}
      <span style={{ whiteSpace: 'pre-wrap' }}>
        <span
          ref={textRef}
          style={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: isExpanded ? 'unset' : 2,
            overflow: 'hidden',
          }}
        >
          {content}
        </span>
        {showButton && (
          <button
            onClick={toggleNote}
            className="btn btn-link p-0 ms-1"
            data-testid={`expandable-note-item-${itemIndex}-toggle`}
            style={{
              fontSize: '0.85rem',
              color: '#007bff',
              textDecoration: 'none',
              display: 'inline',
            }}
          >
            <P size="small">
              {isExpanded ? 'Lihat lebih sedikit' : 'Lihat selengkapnya'}
            </P>
          </button>
        )}
      </span>
    </div>
  )
}

const ExpandableNoteList = ({ notes }) => {
  const parsed = Array.isArray(notes)
    ? notes
        .map((n) => {
          if (typeof n === 'string') return { ts: null, notes: n }
          if (n && typeof n === 'object' && typeof n.notes === 'string')
            return n
          return null
        })
        .filter(Boolean)
    : [{ ts: null, notes: typeof notes === 'string' ? notes : '' }]

  return (
    <div className="d-flex flex-column gap-2 py-1" data-testid="expandable-note-list">
      {parsed.map((item, idx) => (
        <NoteItem key={idx} item={item} itemIndex={idx} />
      ))}
    </div>
  )
}

export default ExpandableNoteList
